import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

import { Chevron } from '@solent-university/solent-icons';

export const Wrapper = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
`;

export const Button = styled(animated.button)`
    ${({ theme }) => css`
        background-color: ${theme.colors.secondary.tints[1].hex};
        border: none;
        border-radius: 50%;
        cursor: pointer;
        transition: opacity 200ms ease;
        border: ${theme.commonStyles.brandPixel} solid ${theme.colors.tertiary.hex};
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        outline: 0.5rem solid ${theme.colors.secondary.hex};
        height: 100%;
        width: 100%;
        transform: translateZ(0);

        &:hover {
            opacity: 1;
        }

        &:focus {
            opacity: 1;
        }
    `}
`;

export const Icon = styled(Chevron)<{ $type: 'previous' | 'next' }>`
    width: 60%;
    height: 60%;
    max-width: 1.5rem;
    max-height: 1.5rem;

    ${({ $type }) =>
        $type === 'previous' &&
        css`
            transform: rotate(180deg);
        `}
`;
